export const ADD_PERMISSION_FAILURE = 'ADD_PERMISSION_FAILURE';
export const ADD_PERMISSION_LOADING = 'ADD_PERMISSION_LOADING';
export const ADD_PERMISSION_SUCCESS = 'ADD_PERMISSION_SUCCESS';

export const UPDATE_PERMISSION_FAILURE = 'UPDATE_PERMISSION_FAILURE';
export const UPDATE_PERMISSION_LOADING = 'UPDATE_PERMISSION_LOADING';
export const UPDATE_PERMISSION_SUCCESS = 'UPDATE_PERMISSION_SUCCESS';

export const FETCH_PERMISSION_FAILURE = 'FETCH_PERMISSION_FAILURE';
export const FETCH_PERMISSION_LOADING = 'FETCH_PERMISSION_LOADING';
export const FETCH_PERMISSION_SUCCESS = 'FETCH_PERMISSION_SUCCESS';

export const FETCH_BY_ID_PERMISSION_FAILURE = 'FETCH_BY_ID_PERMISSION_FAILURE';
export const FETCH_BY_ID_PERMISSION_LOADING = 'FETCH_BY_ID_PERMISSION_LOADING';
export const FETCH_BY_ID_PERMISSION_SUCCESS = 'FETCH_BY_ID_PERMISSION_SUCCESS';

export const DELETE_PERMISSION_FAILURE = 'DELETE_PERMISSION_FAILURE';
export const DELETE_PERMISSION_LOADING = 'DELETE_PERMISSION_LOADING';
export const DELETE_PERMISSION_SUCCESS = 'DELETE_PERMISSION_SUCCESS';
